export default __webpack_public_path__ + "static/media/youtube.3cb438ca.svg";